import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const ManageCreditFormSchema = z.object({
  amount: z.number(),
  type: z.string(),
  description: z.string(),
});

export type ManageCreditForm = z.infer<typeof ManageCreditFormSchema>;

const manageCreditFormDefaultValues: ManageCreditForm = {
  amount: 0,
  type: '',
  description: '',
};

export const useManageCreditForm = () => {
  const form = useForm({
    defaultValues: manageCreditFormDefaultValues,
    resolver: zodResolver(ManageCreditFormSchema),
    reValidateMode: 'onBlur',
  });

  return form;
};
